import { PayCircleFilled } from '@ant-design/icons';
import { Button, message, Tooltip } from 'antd';
import React, { useState } from 'react';
import { fetchAPI } from '../../utils/api';

const OrderGenerateNcprSpid = (props: {
  orderId: number;
  reloadOrderList: () => void;
  onOpenChange?: (open: boolean) => void;
}) => {
  const [loading, setLoading] = useState(false);

  const startGenerating = async () => {
    setLoading(true);
    try {
      await fetchAPI(`order/${props.orderId}/ncpr-spid`, { method: 'POST' });
      props.reloadOrderList();
    } catch (error) {
      message.error('Failed generate NCPR SPID');
      if (!!error.message) {
        message.error(`${error.code}: ${error.message}`);
      }
    }
    setLoading(false);
  };

  return (
    <Tooltip title="Generate NCPR SPID">
      <Button
        icon={<PayCircleFilled />}
        onClick={() => {
          props.onOpenChange?.(false);
          startGenerating();
        }}
        loading={loading}
      >
        Generate SPID
      </Button>
    </Tooltip>
  );
};

export default OrderGenerateNcprSpid;
